var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "clearfix mb-0"
  }, [_c('span', {
    staticClass: "float-md-left d-block d-md-inline-block mt-25"
  }, [_vm._v(" " + _vm._s(_vm.copyrightPrefix) + " "), _c('b-link', {
    staticClass: "ml-25",
    attrs: {
      "href": _vm.siteUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.siteName))]), _c('span', {
    staticClass: "d-none d-sm-inline-block"
  }, [_vm._v(", All rights Reserved")])], 1), _c('span', {
    staticClass: "float-md-right d-none d-md-block"
  }, [_vm._v(" " + _vm._s(_vm.footerCreditText) + " "), _vm.showFooterHeart ? _c('feather-icon', {
    staticClass: "text-danger stroke-current",
    attrs: {
      "icon": "HeartIcon",
      "size": "21"
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }